export default "__VITE_ASSET__y3Hz9Bjc__"